import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Return } from "../../returns.types";
import { requestGetReturns } from "./getReturns.request";

const useGetOrders = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<Return>, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["order", "admin", "returns-all", requestParams],
    queryFn: async () => await requestGetReturns(requestParams),
    onError: toastServerError,
    ...options
  });

  return { returns: data?.data, meta: data?.meta, ...rest };
};

export default useGetOrders;
